import { useEffect, useState } from "react";

// The web app hides its "AI Agent / Chat with Client" tabs once the sidebar says it offers the
// client chat itself. It then reports whether the open loan has one, and opens it when asked.
export const OFFERS_CLIENT_CHAT_KEY = "sidebar-offers-client-chat";
export const CLIENT_CHAT_KEY = "client-chat";
export const OPEN_CLIENT_CHAT_KEY = "open-client-chat";

const NO_CLIENT_CHAT = { isAvailable: false, unreadCount: 0, label: "Chat with client" };

function getHostWindow() {
  return window.parent && window.parent !== window ? window.parent : null;
}

/** The loan's chat with the client, which lives in the web app: whether there is one, its unread count, and how to open it. */
export function useClientChatLink(isEnabled) {
  const [clientChat, setClientChat] = useState(NO_CLIENT_CHAT);

  useEffect(() => {
    const hostWindow = getHostWindow();
    if (!isEnabled || !hostWindow) {
      return undefined;
    }

    const handleMessage = (event) => {
      if (event.source !== hostWindow || event.data?.key !== CLIENT_CHAT_KEY) {
        return;
      }

      const { isAvailable = false, unreadCount = 0, label = NO_CLIENT_CHAT.label } = event.data.value || {};
      setClientChat({ isAvailable: Boolean(isAvailable), unreadCount: Number(unreadCount) || 0, label });
    };
    window.addEventListener("message", handleMessage);
    hostWindow.postMessage({ key: OFFERS_CLIENT_CHAT_KEY, value: true }, "*");

    return () => window.removeEventListener("message", handleMessage);
  }, [isEnabled]);

  const open = () => getHostWindow()?.postMessage({ key: OPEN_CLIENT_CHAT_KEY }, "*");

  return { ...clientChat, open };
}
